import jQuery from 'jquery';
import UIkit from 'uikit';
import initGreeting from './base/hello';
import initOrientationHelper from './base/orientation';
import slick from 'slick-carousel'
import GAnalytics from 'ganalytics'

const ga = GAnalytics('UA-7049289-14');

initOrientationHelper()

// Only attempt to bind events (and Slick) if an element on the page actually exists.
if ($("#js-current-page").length) {
  $(window).on("load", function() {
    const currentPage = $("#js-current-page")
    const slickElement = $('.js-comic-book')
    let activeSlide = 1
    $(".lf-comic-image").css("display", "block");

    slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
      let i = (currentSlide ? currentSlide : 0) + 1
      let activeSlide = i
      currentPage.text(i)

      $("#next-outer, .js-comic-book").click(function() {
        $('.js-comic-book').slick('slickNext')
      })

      $("#prev-outer").click(function() {
        $('.js-comic-book').slick('slickPrev')
      })

      $(document).on('keydown', function(e) {
        if (e.keyCode == 37) { // left arrow
          $('.js-comic-book').slick('slickPrev')
        }
        if (e.keyCode == 39) { // right arrow
          $('.js-comic-book').slick('slickNext')
        }
      })

      ga.send('event', {
        ec: 'Comic',
        ea: 'Page Viewed',
        el: activeSlide
      })
    })

    slickElement.slick({
      dots: false,
      infinite: false,
      speed: 0,
      slidesToShow: 1,
      adaptiveHeight: false,
      arrows: true,
      lazyLoad: 'ondemand',
      nextArrow: $('#next'),
      prevArrow: $('#prev'),
    });
  })
}



// WEBPACK FOOTER //
// ./frontend/assets/js/App.js